import { Flex, Spinner } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Screen } from '@component/screen/screen.component';
import styled from 'styled-components';

const StyledFullScreenLoading = styled(Flex)`
	min-height: 100%;
	background: ${tokens.color.bg.page};
`;

const StyledSpinner = styled(Spinner)`
	color: ${tokens.color.content.placeholder};
`;

interface ScreenLoadingProps {
	showSpinner?: boolean;
}

export function ScreenLoading({ showSpinner = true }: ScreenLoadingProps) {
	return (
		<Screen route='careNavigationLoading' isActivated>
			<StyledFullScreenLoading grow='1' align='center' justify='center'>
				{showSpinner ? <StyledSpinner size='large' /> : null}
			</StyledFullScreenLoading>
		</Screen>
	);
}
